import { Component, Input } from "@angular/core";

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
})
export class ResultComponent {
  @Input() originZip: string = '';
  @Input() destinationZip: string = '';
  @Input() miles: number = 0;

  constructor() {}
}
